import script from "./ListClients.vue?vue&type=script&setup=true&lang=js"
export * from "./ListClients.vue?vue&type=script&setup=true&lang=js"

import "./ListClients.vue?vue&type=style&index=0&id=e8a1fcae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8a1fcae"]])

export default __exports__